import styled from "styled-components";
import { Box } from "@material-ui/core";
import { theme } from "../../util/theme";

export const CircularWrapper = styled(Box)`
  .MuiCircularProgress-colorPrimary {
    color: ${theme.color.primary};
  }
`;